// extracted by mini-css-extract-plugin
module.exports = {"stationDistance":"style_stationDistance__pOqGh","item":"style_item__k9I7E","invertColor":"style_invertColor__XBrno","name":"style_name__zohw3","distance":"style_distance__ahQ_T"};